<rk-break-header
  [calendarDatesChanged]="calendarDatesChanged | async"
  (addBreak)="breakCreation()"
  (dateSelectDatesChanged)="dateSelectDatesChanged($event)"
  (calendarPrevious)="calendarPrevious()"
  (calendarNext)="calendarNext()"
  (calendarToday)="calendarToday()"
></rk-break-header>

<div class="break-shell--card" [class.tiny-header]="$tinyHeader()">
  <rk-loader
    *ngIf="isLoading$ | async"
    class="absolute bg-white z-10 flex items-center justify-center inset-0"
    [size]="48"
    [isLoading]="true"
  ></rk-loader>
  @if (radioTz$ | async) {
    <rk-mobile-calendar-header
      class="block md:hidden"
      [tinyHeader]="$tinyHeader()"
      [datesRange$]="datesRange$"
      [currentDay$]="currentDay$"
      (setCurrentDay)="setCurrentDay($event)"
    ></rk-mobile-calendar-header>
  }
  <div class="list-header hidden md:grid">
    <full-calendar
      #calendar
      class="break-shell--calendar"
      [options]="calendarOptions"
    ></full-calendar>
  </div>
  <rk-break-list
    *ngIf="(breaks$ | async)?.length; else noTracks"
    [breaks]="breaks$ | async"
    [ngClass]="{
      'selection-active': (selectedBreaks$ | async),
    }"
    (scrolled)="scrolled($event)"
  ></rk-break-list>
</div>

<ng-template #dayHeaderContentContainer></ng-template>

<ng-template #noTracks>
  <div class="break-empty gap-4 md:gap-8 relative md:-mt-8">
    <img class="w-2/3 md:w-48" src="/assets/playlist-empty.svg" />
    <div class="font-semibold text-lg" translate>SCHEDULE.PLANNING.BREAK_EMPTY</div>
  </div>
</ng-template>

<rk-mobile-fab-button (click)="addBreak()"></rk-mobile-fab-button>
